import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HelpCircle } from "lucide-react";
import { UrgencyPill } from "@/components/Badges";
import { useLang } from "@/context/LanguageContext";

export default function WhatIf() {
  const { lang, t } = useLang();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get(`/what-if?lang=${lang}`).then((r) => setItems(r.data.items || []));
  }, [lang]);
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold flex items-center gap-2">
          <HelpCircle className="w-6 h-6 text-[#C85A32]" /> {t("whatif.title")}
        </h1>
        <p className="text-[#4A525A] mt-1">{t("whatif.subtitle")}</p>
      </div>
      <div className="space-y-3">
        {items.map((it, idx) => (
          <div key={idx} className="bg-white border-2 border-[#E4DDD3] rounded-2xl">
            <button
              onClick={() => setOpen(open === idx ? null : idx)}
              data-testid={`whatif-toggle-${idx}`}
              className="pod-focus w-full flex items-center justify-between p-5 text-left"
            >
              <div className="flex items-center gap-3">
                <UrgencyPill urgency={it.urgency} />
                <div className="text-lg font-bold">{it.q}</div>
              </div>
              <span className="text-[#C85A32] font-bold text-sm">{open === idx ? t("whatif.hide") : t("whatif.open")}</span>
            </button>
            {open === idx && (
              <div className="border-t border-[#E4DDD3] p-5 space-y-3 bg-[#FBF9F5]" data-testid={`whatif-body-${idx}`}>
                <Row label={t("whatif.what")} value={it.what} />
                <Row label={t("whatif.check")} value={it.check} />
                <Row label={t("whatif.who")} value={it.who} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
function Row({ label, value }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-widest text-[#707880] font-semibold">{label}</div>
      <div className="mt-1">{value}</div>
    </div>
  );
}
